<div class="pt-container">
  <!-- â”€â”€ COVER IMAGE â”€â”€ -->
  <!--
    DOUBLE click, not single.

    Single click now belongs to selection in ProjectsComponent, and
    the two cannot share the gesture: a click that navigates away can
    never be the first half of a Ctrl+Click or Shift+Click range. This
    is where every file manager puts open, so it is also what the
    operator will try first.

    The explicit open buttons further down the tile are still single
    click. They are <button>s, which the grid's click handler skips,
    so a one-click route to a specific Draft or Book survives.
  -->
  <div class="pt-cover" (dblclick)="open(draft)">
    <app-project-draft-cover-image [draft]="draft"></app-project-draft-cover-image>
  </div>

  <!-- â”€â”€ TITLE BAR (compact) â”€â”€ -->
  <div class="pt-title-bar">
    <!--
      Double click to rename in place, for the same reason the cover
      moved: a single click here is a selection now.

      A gesture nothing advertises is not a feature, so the overflow
      menu grew a Rename entry that does the same thing. That entry is
      the discoverable path; this one is the fast path for anyone who
      expects it to work.
    -->
    <div class="pt-title-content" *ngIf="!editingTitle" (dblclick)="startEditTitle($event)">
      <span class="pt-title">{{ draft.title ? ((draft.title.length > 50) ? (draft.title | slice:0:50) + 'â€¦' : draft.title) : ('No Title Set' | languageString) }}</span>
    </div>
    <input *ngIf="editingTitle" class="pt-title-input" #titleInput
           [value]="draft.title || ''"
           maxlength="40"
           (blur)="commitTitle(titleInput.value)"
           (keydown.enter)="titleInput.blur()"
           (keydown.escape)="cancelTitle(titleInput)">

    <!-- Quick Actions -->
    <div class="pt-quick-actions">
      <button mat-icon-button class="pt-quick-btn" [matMenuTriggerFor]="draftMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <mat-menu #draftMenu="matMenu">
      <button mat-menu-item (click)="open(draft)">
        <mat-icon>edit</mat-icon><span i18n="@@Edit Draft">Edit Draft</span>
      </button>
      <button mat-menu-item (click)="startRename()">
        <mat-icon>edit</mat-icon><span i18n="@@Rename">Rename</span>
      </button>
      <button mat-menu-item (click)="makePrimary(draft, $event.target)" *ngIf="draft !== draft.project.primaryDraft">
        <mat-icon>favorite</mat-icon><span i18n="@@Make Primary Draft">Make Primary Draft</span>
      </button>
      <button mat-menu-item (click)="makeBook(draft, $event.target)" [disabled]="!canBookBeMade(draft)">
        <mat-icon>lock</mat-icon><span i18n="@@Make Book">Make Book</span>
      </button>
      <button mat-menu-item (click)="copy(draft, $event.target)">
        <mat-icon>copy</mat-icon><span i18n="@@Copy Draft">Copy Draft</span>
      </button>
      <button mat-menu-item (click)="deleteDraft(draft, $event.target)">
        <mat-icon>delete</mat-icon><span i18n="@@Delete Draft">Delete Draft</span>
      </button>
      <button mat-menu-item (click)="createNewProjectWithDraft(draft, $event.target)">
        <mat-icon>copy</mat-icon><span i18n="@@Create New Project With Draft">Create New Project With Draft</span>
      </button>
      <button mat-menu-item (click)="changeProject(draft, $event.target)">
        <mat-icon>drive_file_move</mat-icon><span i18n="@@Move Draft to A Different Project">Move Draft to A Different Project</span>
      </button>
      <button mat-menu-item (click)="moveProject(draft.project, $event.target)">
        <mat-icon>drive_file_move</mat-icon><span i18n="@@Move Project To A New Folder">Move Project To A New Folder</span>
      </button>
      <button mat-menu-item (click)="addToCart(draft)">
        <mat-icon>shopping_cart</mat-icon><span i18n="@@Add Draft to Cart">Add Draft to Cart</span>
      </button>
    </mat-menu>
  </div>

  <!-- â”€â”€ DRAFT DETAILS â”€â”€ -->
  <div class="pt-sub-items">
    <div class="pt-sub-item pt-draft">
      <div class="pt-sub-header">
        <mat-icon *ngIf="draft === draft.project.primaryDraft" class="pt-primary-icon">favorite</mat-icon>
        <span class="pt-sub-label"><strong i18n="@@Draft Prefix">Draft:</strong> {{draft.ID}}</span>
        <span class="pt-sub-age">({{getDaysOldString(draft.lastUpdate)}})</span>
        <span class="pt-sub-actions">
          <button mat-icon-button class="pt-sub-action-btn" (click)="open(draft)" i18n-matTooltip="@@Edit Draft" matTooltip="Edit Draft">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
      </div>
      <div class="pt-sub-props">
        <span i18n-title="@@Trim Size" title="Trim Size">{{formatTrim(draft.draftBody?.width, draft.draftBody?.height)}}</span>
        <span i18n-title="@@Binding Type" title="Binding Type">{{getLanguageString(draft.bindingType)}}</span>
        <span i18n-title="@@Interior Type" title="Interior Type">{{getLanguageString(draft.interiorType)}}</span>
        <span i18n-title="@@Paper Type" title="Paper Type">{{getPaperTypeName(draft.draftBody?.paperType_ID)}}</span>
        <span i18n-title="@@Lamination Type" title="Lamination Type">{{getLanguageString(draft.draftCover?.laminateType)}}</span>
      </div>
      <div class="pt-sub-resource">
        <span class="pt-res-label" i18n="@@Cover">Cover</span>
        <span class="pt-res-values">
          <span i18n-title="@@Cover Scale" title="Cover Scale">{{formatScale(draft.draftCover?.documentScale)}}</span>
          <span i18n-title="@@Cover Vertical Shift" title="Cover Vertical Shift">{{formatShift(draft.draftCover?.verticalShift)}}</span>
          <span i18n-title="@@Cover Horizontal Shift" title="Cover Horizontal Shift">{{formatShift(draft.draftCover?.horizontalShift)}}</span>
        </span>
          <span class="pt-res-id"
                [style.background-color]="getResourceStatusColor(draft.draftCover)"
                [style.background-image]="getResourceStripe(draft.draftCover)"
                [class.res-badge-actionable]="isResourceActionable(draft.draftCover)"
                [attr.role]="isResourceActionable(draft.draftCover) ? 'button' : null"
                [attr.tabindex]="isResourceActionable(draft.draftCover) ? 0 : null"
                (click)="onResourceBadgeClick(draft.draftCover, $event)"
                (keydown.enter)="onResourceBadgeClick(draft.draftCover, $event)"
                (keydown.space)="onResourceBadgeClick(draft.draftCover, $event)"
                [title]="getResourceHoverText(draft.draftCover, 'Cover Resource ID')">{{getResourceDisplayString(draft.draftCover)}}</span>
          <app-preview-quality-indicator [compact]="true"
                                         [resourceId]="draft.draftCover?.resource_ID"></app-preview-quality-indicator>
      </div>
      <div class="pt-sub-resource">
        <span class="pt-res-label" i18n="@@Body">Body</span>
        <span class="pt-res-values">
          <span i18n-title="@@Body Scale" title="Body Scale">{{formatScale(draft.draftBody?.documentScale)}}</span>
          <span i18n-title="@@Body Left Vertical Shift" title="Body Left Vertical Shift">{{formatShift(draft.draftBody?.leftVerticalShift)}}</span>
          <span i18n-title="@@Body Left Horizontal Shift" title="Body Left Horizontal Shift">{{formatShift(draft.draftBody?.leftHorizontalShift)}}</span>
          <span i18n-title="@@Body Right Vertical Shift" title="Body Right Vertical Shift">{{formatShift(draft.draftBody?.rightVerticalShift)}}</span>
          <span i18n-title="@@Body Right Horizontal Shift" title="Body Right Horizontal Shift">{{formatShift(draft.draftBody?.rightHorizontalShift)}}</span>
        </span>
          <span class="pt-res-id"
                [style.background-color]="getResourceStatusColor(draft.draftBody)"
                [style.background-image]="getResourceStripe(draft.draftBody)"
                [class.res-badge-actionable]="isResourceActionable(draft.draftBody)"
                [attr.role]="isResourceActionable(draft.draftBody) ? 'button' : null"
                [attr.tabindex]="isResourceActionable(draft.draftBody) ? 0 : null"
                (click)="onResourceBadgeClick(draft.draftBody, $event)"
                (keydown.enter)="onResourceBadgeClick(draft.draftBody, $event)"
                (keydown.space)="onResourceBadgeClick(draft.draftBody, $event)"
                [title]="getResourceHoverText(draft.draftBody, 'Body Resource ID')">{{getResourceDisplayString(draft.draftBody)}}</span>
          <app-preview-quality-indicator [compact]="true"
                                         [resourceId]="draft.draftBody?.resource_ID"></app-preview-quality-indicator>
      </div>
    </div>
  </div>
</div>
